import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const NotFound = () => {
  const userProfile = localStorage.getItem("userProfile");
  const { t } = useTranslation();

  return (
    <div style={styles.container}>
      <Helmet>
        <title>{t("not_found.meta_title")}</title>
      </Helmet>

      <div style={styles.content}>
        <h1 style={styles.errorCode}>404</h1>
        <h2 style={styles.title}>{t("not_found.title")}</h2>
        <p style={styles.message}>
          {t("not_found.text")}
        </p>
        {userProfile && (
          <Link to="/dashboard" style={styles.button}>
            {t("not_found.back")}
          </Link>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(180deg, #f3f8ff 0%, #ffffff 100%)",
    fontFamily: "inherit",
    textAlign: "center",
    padding: "20px",
  },
  content: {
    maxWidth: "500px",
  },
  errorCode: {
    fontSize: "120px",
    fontWeight: "900",
    margin: "0",
    lineHeight: "1",
    background: "linear-gradient(120deg, #0d6ef0 0%, #3b8cff 45%, #6c5cff 100%)",
    WebkitBackgroundClip: "text",
    backgroundClip: "text",
    color: "transparent",
  },
  title: {
    fontSize: "24px",
    fontWeight: "800",
    color: "#0b1b3a",
    marginTop: "20px",
  },
  message: {
    fontSize: "16px",
    color: "#6b7a94",
    marginTop: "15px",
    marginBottom: "30px",
    lineHeight: "1.6",
  },
  button: {
    display: "inline-block",
    padding: "12px 30px",
    background: "linear-gradient(120deg, #0d6ef0 0%, #3b8cff 45%, #6c5cff 100%)",
    color: "#fff",
    textDecoration: "none",
    borderRadius: "50px",
    fontWeight: "700",
    boxShadow: "0 10px 24px -10px rgba(13, 110, 240, 0.7)",
  },
};

export default NotFound;
